import { useEffect } from 'react';
import { useAuth } from 'react-oidc-context';

import { ArrowLeft16 } from '@ingrid/iconography/react';
import { Link, PreApp } from '@ingrid/luterkort-react';

import { useTranslation } from '~src/i18n/use-translation';
import { AppRoute } from '~src/main/routes';

export function AppExpiredPage() {
  const { isAuthenticated, signoutSilent } = useAuth();
  const { t } = useTranslation();

  useEffect(() => {
    if (!isAuthenticated) {
      return;
    }

    void (async () => {
      await signoutSilent();
    })();
  }, [isAuthenticated, signoutSilent]);

  return (
    <PreApp.Wrapper>
      <PreApp.Stack>
        <PreApp.Title>{t('auth.expired.title')}</PreApp.Title>
        <PreApp.Subtitle>{t('auth.expired.text')}</PreApp.Subtitle>

        <Link href={AppRoute.ROOT}>
          <ArrowLeft16 />
          {t('auth.signIn')}
        </Link>
      </PreApp.Stack>
    </PreApp.Wrapper>
  );
}
